import { Component, Input, OnDestroy } from '@angular/core';
import { LicenseService } from '../../services/license.service';
import {Subscription, Subject, Observable} from 'rxjs/';

import { RxComponent } from '../../../shared/components/common/rx.component';
import {ScormCloudService} from '../../services/scorm-cloud.service';
import {del} from '../../../../../node_modules/@types/selenium-webdriver/http';
import { v4 as uuid } from 'uuid';

export class BaseTileComponent extends RxComponent implements OnDestroy {

    protected status: string = 'loading';
    protected target: Array<any> = [];
    protected name: string;
    protected errorMessage: string;

    protected messages: any = {};

    protected deliverableStatus: any = {};

    protected processComplete = new Subject();

    constructor(
    ) {
        super();
        this.messages.inProgress = 'Your content will be ready soon'
        this.messages.upToDate = 'Your content is ready'
        this.messages.outOfDate = 'Your content is ready'
        this.messages.expired = 'Your content is expired'
        this.messages.invalid = 'There is a problem, contact your provider'
    }

    init(licenseService: LicenseService, deliverable: any, createTarget: boolean) {
        if (deliverable.status !== 'inProgress') {
            this.complete(deliverable, createTarget);
            return;
        }

        this.processComplete
            .do(_ => {
                this.deliverableStatus.message = 'Done!';
                this.deliverableStatus.progress = 100;
            })
            .delay(2000)
            .bindToLifecycle(this)
            .subscribe(_ => this.complete(deliverable, createTarget));

        licenseService.checkStatus(deliverable.id)
            .takeUntil(this.processComplete)
            .bindToLifecycle(this)
            .subscribe(status => {
                deliverable.status = status.status;
                if (deliverable.status === 'inProgress' || deliverable.status === 'queued') {
                    this.deliverableStatus = status;
                } else {
                    this.processComplete.next(true);
                }
            });

        this.update(deliverable, createTarget);
    }

    initScormCloud(scormCloudService: ScormCloudService, profile: any,  deliverable: any, createTarget: boolean){
        /*this.deliverableStatus.message = 'Done!';
        this.deliverableStatus.progress = 100;
        this.complete(deliverable, createTarget);*/
        let checkStatus = new Subject<any>();
        let checkTokenId = new Subject<any>();
        let checkProgress = new Subject<any>();
        let registerDeliverable = new Subject<any>();
        let registrationId = uuid();
        let processTokenComplete = new Subject<any>();
        let processImportComplete = new Subject<any>();

        registerDeliverable
          .do(_ => {
            this.deliverableStatus.message = 'Done!';
            this.deliverableStatus.progress = 100;
           /* console.log('Creating registration');*/
          })
          .flatMap(_ => scormCloudService.createRegistration({
            registrationId: registrationId,
            solarDeliverableId: deliverable.id,
            learner: {
              email: profile.username,
              firstName: profile.firstName,
              lastName: profile.lastName,
              id: profile.id
            }
          }))
          .flatMap(_ => scormCloudService.updateRegistrationId({
            solarDeliverableId: deliverable.id,
            registrationId: registrationId
          }))
          .catch(_ => Observable.throw(this.error()))
          .subscribe(_ => {
            deliverable.registrationId = registrationId;
            deliverable.status = 'upToDate';
            this.complete(deliverable, createTarget);
            }, err => this.error()
          );

        processImportComplete
          .delay(2000)
          .bindToLifecycle(this)
          .subscribe(_ => {
            /*console.log('Import completed')*/
            registerDeliverable.next(true);
          }, err => this.error()
        );

        checkProgress
          .subscribe(tokenId => {
            /*console.log('Checking progress of import (Zephyr)')*/
            scormCloudService.checkImportResults(tokenId)
              .takeUntil(processImportComplete)
              .bindToLifecycle(this)
              .subscribe(data => {
                deliverable.status = data.progress;
                if(data.progress < 100){
                  this.deliverableStatus.message = 'inProgress';
                  this.deliverableStatus.progress = data.progress;
                } else {
                  processImportComplete.next(true);
                }
              }, err => this.error());
          });

        processTokenComplete
          .delay(2000)
          .bindToLifecycle(this)
          .subscribe(id => {
            /*console.log('Token fetched (Solar)')*/
            deliverable.scormCloudTokenId = id;
            checkProgress.next(id);
          }, err => this.error());

        checkTokenId.subscribe(id => {
          scormCloudService.getImportTokenId(id)
            /*.do(_ => console.log('Checking token ID (Solar)'))*/
            .takeUntil(processTokenComplete)
            .bindToLifecycle(this)
            .subscribe(data => {
              if(data && data.tokenId)
                processTokenComplete.next(data.tokenId);
            }, err => this.error())
        });

        /*console.log('Checking status of deliverable')*/
        if(deliverable.scormCloudTokenId && deliverable.registrationId){
          this.deliverableStatus.message = 'Done!';
          this.deliverableStatus.progress = 100;
          this.complete(deliverable, createTarget);
        }else if(!deliverable.registrationId && deliverable.scormCloudTokenId) {
          /*console.log('Registering user in Scorm Cloud (Zephyr)')*/
          //registerDeliverable.next(deliverable.id);
          checkProgress.next(deliverable.scormCloudTokenId);
        }else{
          //call zephyr
          /*console.log('Importing course (Zephyr)')*/
          scormCloudService.importCourse({
            bucket: deliverable.sourceBucket,
            key: deliverable.sourceKey,
            solarDeliverableId: deliverable.id
          }).subscribe(_ => {
            checkTokenId.next(deliverable.id);
          }, err => {
            this.error();
            deliverable.status = 'error';
          })
        }
    }

    complete(deliverable: any, createTarget: boolean) {
        this.update(deliverable, createTarget);
        this.status = deliverable.status == 'upToDate' ? 'ready' : 'error';
    }

    update(deliverable: any, createTarget: boolean) {
        //TODO: name can be null ???
        this.name = deliverable.name || 'Learning Material';
        if (createTarget && deliverable.type === 'scormcloud') {
            this.target = ['/app', deliverable.type, deliverable.registrationId, deliverable.id];
        }else if (createTarget) {
          this.target = ['/app', deliverable.type, deliverable.assignmentId, deliverable.id];
        }

        this.errorMessage = this.messages[deliverable.status] || 'There is a problem, contact your provider';
    }

    error(){
      /*console.log('Throwing error')*/
      this.deliverableStatus.message = 'Error importing course';
      this.deliverableStatus.progress = 0;
      this.status = 'error';
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/content/tile.component.ts